<template>
  <div>
    <el-dialog :title="form.id ? '编辑' : '新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh"
      width="1000px" class="meeting-box">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="meeting-form">
          <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small"
            label-width="120px">
            <!-- 1. 会议类型模块 -->
            <div class="form-section">
              <h3 class="section-title">会议类型</h3>
              <el-form-item prop="categoryId" class="no-margin-left">
                <div class="category-buttons">
                  <el-button v-for="item in meetingCategoryOptions" :key="item.id"
                    :type="form.categoryId === item.id ? 'primary' : ''"
                    :class="{ 'category-active': form.categoryId === item.id }" @click="selectCategory(item.id)">
                    {{ item.name }}
                  </el-button>
                </div>
              </el-form-item>
            </div>

            <!-- 2. 基础信息模块 -->
            <div class="form-section">
              <h3 class="section-title">基础信息</h3>
              <div class="form-grid">
                <el-form-item label="会议名称：" prop="title">
                  <el-input v-model="form.title" placeholder="请输入会议名称" />
                </el-form-item>
                <el-form-item label="主讲老师：" prop="lecturerIds">
                  <el-select v-model="form.lecturerIds" multiple placeholder="请选择主讲老师" collapse-tags clearable>
                    <el-option v-for="item in lecturerOptions" :key="item.id" :label="item.realName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="会议主图：" prop="imageId" class="full-width">
                  <div class="image-upload">
                    <el-button type="primary" icon="el-icon-plus" plain @click="selectImage">选择图片</el-button>
                    <el-image v-if="imgUrl" :src="imgUrl" :preview-src-list="[imgUrl]" class="preview-image"></el-image>
                  </div>
                </el-form-item>
                <el-form-item label="banner图：" class="full-width">
                  <moreImageUpload v-model="form.bannerUrl" :limit="999" hint-text="限制上传多张，建议尺寸750x500像素以上" />
                </el-form-item>
                <el-form-item label="所在地区：" prop="addressArray">
                  <el-cascader @change="changeCascader" :props="cascaderProps" collapse-tags v-model="form.addressArray"
                    :options="regionOptions" clearable placeholder="请选择省市区"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="address">
                  <el-input v-model="form.address" placeholder="请输入详细地址" readonly>
                    <i slot="suffix" class="el-input__icon el-icon-location-outline" style="color: #1296DB"></i>
                  </el-input>
                  <span class="address" @click="addAddressShow = true"></span>
                </el-form-item>
              </div>
            </div>

            <!-- 3. 限制配置模块 -->
            <div class="form-section">
              <h3 class="section-title">限制配置</h3>
              <div class="form-grid">
                <el-form-item label="报名时间：" prop="signTime">
                  <el-date-picker v-model="form.signTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="会议时间：" prop="meetingTime">
                  <el-date-picker v-model="form.meetingTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="携带人数：">
                  <el-input v-model="form.maxCarryPeople" placeholder="请输入携带人数" />
                  <div class="form-tip" style="color: #E73F3F;">
                    同账号最多成人报名人数限制(不包含本人)
                  </div>
                </el-form-item>
                <el-form-item label="携带儿童：">
                  <el-input v-model="form.maxCarryChildPer" placeholder="请输入携带儿童人数" />
                  <div class="form-tip" style="color: #E73F3F;">
                    1位成人最多携带儿童人数限制
                  </div>
                </el-form-item>
                <el-form-item label="签到距离：" prop="signUpRadius">
                  <el-input v-model="form.signUpRadius" placeholder="请输入签到距离" @input="changeSignUpRadius">
                    <template slot="append">km</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="虚拟报名人数：">
                  <el-input v-model="form.signUpCountVirtual" placeholder="请输入虚拟报名人数" />
                </el-form-item>
              </div>
            </div>
            <!-- 3. 设备签到 -->
            <div class="form-section">
              <h3 class="section-title">设备签到</h3>
              <el-form-item label="设备签到：" prop="isDeviceSignIn" class="required-field">
                <el-radio-group v-model="form.isDeviceSignIn">
                  <el-radio :label="true">允许设备签到</el-radio>
                  <el-radio :label="false">不允许设备签到</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 4. 报名身份/费用限制模块 -->
            <div class="form-section">
              <h3 class="section-title">报名身份/费用限制(收费的会议，送了充值金额-零售价、余额，按照充值推送，没有送充值金额，按照学费推送)</h3>

              <!-- 参与身份选择 -->
              <el-form-item label="参与身份：" prop="participationType" class="required-field">
                <el-radio-group v-model="form.participationType" @change="handleParticipationTypeChange">
                  <el-radio :label="1">所有人免费参与</el-radio>
                  <el-radio :label="2">指定身份参与</el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 指定身份配置 -->
              <div v-if="form.participationType === 2" class="identity-config">
                <!-- 身份列表及费用选项 - 每个身份竖排显示 -->
                <div class="identity-list">
                  <div v-for="identity in identityList" :key="identity.id" :class="['identity-item']">
                    <div>
                      <div class="identity-name">{{ identity.name }}</div>
                      <div class="identity-options">
                        <div class="fee-type-options">
                          <el-radio v-model="identity.feeType" :label="1" @change="handleIdentityFeeChange(identity)"
                            @click.native="
                              handleRadioClick(identity, 1, $event)
                              ">免费</el-radio>
                          <el-radio v-model="identity.feeType" :label="2" @change="handleIdentityFeeChange(identity)"
                            @click.native="
                              handleRadioClick(identity, 2, $event)
                              ">收费</el-radio>
                        </div>
                      </div>
                      <!-- 支付方式配置 -->
                      <div v-if="identity.feeType === 2" class="payment-methods">
                        <el-checkbox-group v-model="identity.enabledPayments"
                          @change="handlePaymentMethodsChange(identity)">
                          <el-checkbox label="cash" :disabled="!getAvailablePayments(identity).includes('cash')
                            ">现金收费</el-checkbox>
                          <el-checkbox label="account" :disabled="!getAvailablePayments(identity).includes(
                            'account'
                          )
                            ">入账金额</el-checkbox>
                          <el-checkbox label="balance" :disabled="!getAvailablePayments(identity).includes(
                            'balance'
                          )
                            ">余额收费</el-checkbox>
                          <el-checkbox label="coin" :disabled="!getAvailablePayments(identity).includes('coin')
                            ">零售价收费</el-checkbox>
                          <el-checkbox label="gift" :disabled="!getAvailablePayments(identity).includes('gift')
                            ">赠送额度收费</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <!-- 费用配置表格 - 当该身份选择收费时显示 -->
                    <div v-if="identity.feeType === 2" class="fee-config-section">
                      <div class="fee-config-table">
                        <div class="table-header">
                          <div class="header-cell">收费顺序</div>
                          <div class="header-cell">
                            <span v-if="identity.enabledPayments.includes('cash')"
                              class="required-asterisk">*</span>现金收费
                          </div>
                          <div class="header-cell" style="width: 218px;">
                            入账金额
                            <!-- 产品 2026-09-09 批注：大区/地区/县区经理这三类的入账账户只能选「零售价」，
                                 运营容易按现金面额填，导致入账金额与零售价口径对不上。这里给一句红色提示。
                                 条件走 isRetailOnlyAccount()，与下面 getAccountTypeOptions 里
                                 「只支持零售价」用的是**同一份身份清单**，别在这儿再抄一遍名字 —— 
                                 抄一遍就意味着以后加一个同类身份要改两处，漏一处不报错。 -->
                            <div v-if="isRetailOnlyAccount(identity)" class="account-amount-hint">
                              请换算为零售价的入账金额进行配置
                            </div>
                          </div>
                          <div class="header-cell">
                            <span v-if="
                              identity.enabledPayments.includes('balance')
                            " class="required-asterisk">*</span>余额收费
                          </div>
                          <div class="header-cell">
                            <span v-if="identity.enabledPayments.includes('coin')"
                              class="required-asterisk">*</span>零售价收费
                          </div>
                          <div class="header-cell">
                            <span v-if="identity.enabledPayments.includes('gift')"
                              class="required-asterisk">*</span>赠额收费
                          </div>
                          <div class="header-cell">操作</div>
                        </div>

                        <div class="table-body">
                          <div v-for="(fee, index) in identity.feeList" :key="index" class="table-row">
                            <div class="table-cell">
                              {{ getFeeOrderText(index) }}
                            </div>
                            <div class="table-cell">
                              <el-input v-model="fee.amount" placeholder="请输入金额 " size="small" :disabled="!identity.enabledPayments.includes('cash')
                                "></el-input>
                            </div>
                            <div class="table-cell" style="width: 218px;">
                              <div style="display: flex; align-items: center; gap: 8px;">
                                <el-select v-model="fee.giftAccountType" placeholder="请选择" size="small"
                                  style="flex: 1; min-width: 100px;" :disabled="!identity.enabledPayments.includes(
                                    'account'
                                  ) ||
                                    !getAvailablePayments(identity).includes(
                                      'account'
                                    )
                                    ">
                                  <el-option v-for="option in getAccountTypeOptions(
                                    identity, fee
                                  )" :key="option.value" :label="option.label" :value="option.value" :disabled="option.disabled"></el-option>
                                </el-select>
                                <el-input v-model="fee.giftAmount" placeholder="输入金额" size="small"
                                  style="flex: 1; min-width: 100px;" :disabled="!identity.enabledPayments.includes(
                                    'account'
                                  ) ||
                                    !getAvailablePayments(identity).includes(
                                      'account'
                                    )
                                    "></el-input>
                              </div>
                            </div>
                            <div class="table-cell">
                              <el-input v-model="fee.balanceAmount" placeholder="请输入金额" size="small" :disabled="!identity.enabledPayments.includes('balance')
                                "></el-input>
                            </div>
                            <div class="table-cell">
                              <el-input v-model="fee.coinAmount" placeholder="请输入金额" size="small" :disabled="!identity.enabledPayments.includes('coin')
                                "></el-input>
                            </div>
                            <div class="table-cell">
                              <el-input v-model="fee.tuition" placeholder="请输入金额" size="small" :disabled="!identity.enabledPayments.includes('gift')
                                "></el-input>
                            </div>
                            <div class="table-cell">
                              <el-button type="text" icon="el-icon-plus" @click="addFeeRow(identity)" v-if="
                                canAddFeeRow(identity) &&
                                index === identity.feeList.length - 1
                              "></el-button>
                              <el-button type="text" icon="el-icon-delete" @click="removeFeeRow(identity, index)"
                                v-if="identity.feeList.length > 1"></el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 5. 会议详情模块 -->
            <div class="form-section">
              <h3 class="section-title">会议详情</h3>
              <el-form-item>
                <editor v-model="form.content" :min-height="240" :height="240" :upload-url="uploadUrl" />
              </el-form-item>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">取消</el-button>
            <el-button type="primary" @click="doCreate()">确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <select-img-vue ref="selectImgVue" @created="handleSelectImg" />
    <addAddress :position-dialog="addAddressShow" @handlePositionDialog="handlePositionDialog"
      @updatePositionDialog="updatePositionDialog" @handleCloes="handleCloes" />
  </div>
</template>

<script>
import meetingApi from "@/api/meeting/meeting";
import lecturerApi from "@/api/course/lecturer";
import Editor from "@/components/Editor";
import MoreImageUpload from "@/components/MoreImageUpload";
import selectImgVue from "./selectImg.vue";
import addAddress from "@/components/map/index";
import sysDataconstantApi from "@/api/config/sysDataconstant";
import customerLevelApi from "@/api/sys/customerLevel";

/**
 * 「入账金额」只能走零售价账户的身份（产品 2026-09-09）。
 * 表头的红色提示与 getAccountTypeOptions 第 3 条规则共用这一份清单，
 * 以后再多一个同类身份只改这里一处。
 */
const RETAIL_ONLY_ACCOUNT_IDENTITIES = ["大区经理", "地区经理", "县区经理"];

function initFormBean() {
  const formBean = {
    categoryId: null,
    title: null,
    lecturerIds: [],
    imageId: null,
    addressArray: [],
    address: null,
    meetingTime: [],
    signTime: [],
    signUpRadius: null,
    maxCarryPeople: null,
    maxCarryChildPer: null,
    signUpCountVirtual: null,
    content: null,
    participationType: 1, // 1: 所有人参与, 2: 指定身份参与
    identityType: 1, // 1: 普通员工, 2: 收费
    feeList: [],
    latitude: null,
    longitude: null,
    provinceCode: null,
    isDeviceSignIn: null
  };
  return formBean;
}

export default {
  components: { Editor, MoreImageUpload, selectImgVue, addAddress },
  props: {
    meetingCategoryOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      addAddressShow: false,
      cascaderProps: {
        label: "regionName",
        value: "regionCode",
        children: "child"
      },
      uploadUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload",
      form: initFormBean(),
      formVisible: false,
      formRules: {
        categoryId: [
          { required: true, message: "请选择会议类型", trigger: "change" }
        ],
        title: [{ required: true, message: "请输入会议名称", trigger: "blur" }],
        lecturerIds: [
          {
            required: true,
            message: "请选择主讲老师",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value || !Array.isArray(value) || value.length === 0) {
                callback(new Error("请选择主讲老师"));
              } else {
                callback();
              }
            }
          }
        ],
        imageId: [
          { required: true, message: "请选择会议主图", trigger: "change" }
        ],
        addressArray: [
          { required: true, message: "请选择所在区地区", trigger: "change" }
        ],
        address: [
          { required: true, message: "请选择会议地址", trigger: "change" }
        ],
        meetingTime: [
          { required: true, message: "请选择会议时间", trigger: "change" }
        ],
        signTime: [
          { required: true, message: "请选择报名时间", trigger: "change" }
        ],
        signUpRadius: [
          { required: true, message: "请输入签到距离", trigger: "blur" },
          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "必须为数字值",
            trigger: "blur"
          }
        ],
        participationType: [
          { required: true, message: "请选择参与身份", trigger: "change" }
        ],
        isDeviceSignIn: [
          { required: true, message: "请选择设备签到", trigger: "change" }
        ]
      },
      regionOptions: [],
      lecturerOptions: [],
      imgUrl: "",
      isRepSub: false,
      defaultRadiusValue: 0,
      maxRadiusValue: 1000,
      identityList: []
    };
  },
  computed: {
    /**
     * 获取已选中的主讲老师名字列表
     */
    selectedLecturerNames() {
      if (
        !this.form.lecturerIds ||
        !Array.isArray(this.form.lecturerIds) ||
        this.form.lecturerIds.length === 0
      ) {
        return [];
      }
      if (!this.lecturerOptions || this.lecturerOptions.length === 0) {
        return [];
      }
      return this.form.lecturerIds
        .map(id => {
          const lecturer = this.lecturerOptions.find(item => item.id === id);
          return lecturer ? lecturer.realName : null;
        })
        .filter(name => name !== null);
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    lecturerApi
      .fetchList({ pageNo: 1, pageSize: 1000, isEnable: true })
      .then(({ data }) => {
        this.lecturerOptions = data.list;
      });
    const regionOptions = JSON.parse(localStorage.getItem("addressTree")) || [];
    this.regionOptions = this.formatCascaderData(regionOptions);
    this.getBisicsInfo();
    this.loadIdentityList();

    // 测试数据 - 发布时删除此行
    // this.$nextTick(() => {
    //   this.setDefaultTestData();
    // });
  },
  methods: {
    // 验证费用配置
    validateFeeConfiguration() {
      // 检查携带儿童数量大于0时，是否配置了儿童收费方式
      const maxCarryChildPer = this.form.maxCarryChildPer;
      if (maxCarryChildPer && maxCarryChildPer > 0) {
        // 查找儿童身份（id === 70）
        const childIdentity = this.identityList.find(
          identity => identity.id === 70
        );
        // 如果儿童身份存在但未配置收费方式（feeType为null），提示错误
        if (childIdentity && childIdentity.feeType === null) {
          return "请添加儿童支付方式";
        }
      }

      // 检查每个选择收费的身份是否填写了必填的金额
      for (const identity of this.identityList) {
        if (identity.feeType === 2) {
          // 选择了收费
          for (const fee of identity.feeList) {
            // 检查启用的支付方式对应的金额是否已填写
            if (
              identity.enabledPayments.includes("cash") &&
              (!fee.amount || fee.amount === "")
            ) {
              return `${identity.name}的现金收费金额不能为空`;
            }
            // if (
            //   identity.enabledPayments.includes("account") &&
            //   (!fee.giftAccountType || fee.giftAccountType === "")
            // ) {
            //   return `${identity.name}的入账金额类型不能为空`;
            // }
            // if (
            //   identity.enabledPayments.includes("account") &&
            //   fee.giftAccountType &&
            //   (!fee.giftAmount || fee.giftAmount === "")
            // ) {
            //   return `${identity.name}的入账金额不能为空`;
            // }
            if (
              identity.enabledPayments.includes("balance") &&
              (!fee.balanceAmount || fee.balanceAmount === "")
            ) {
              return `${identity.name}的余额收费金额不能为空`;
            }
            if (
              identity.enabledPayments.includes("coin") &&
              (!fee.coinAmount || fee.coinAmount === "")
            ) {
              return `${identity.name}的零售价收费金额不能为空`;
            }
            if (
              identity.enabledPayments.includes("gift") &&
              (!fee.tuition || fee.tuition === "")
            ) {
              return `${identity.name}的赠送额度收费金额不能为空`;
            }
          }
        }
      }
      return null; // 验证通过
    },
    // 加载身份列表
    loadIdentityList() {
      try {
        const levelList = JSON.parse(localStorage.getItem("levelList")) || [];
        //业务线
        //去掉level=1的数据，level2 名称改为 level2名称+/总监
        this.identityList = levelList
          .filter(level => level.level !== 1) // 过滤掉level=1的数据
          .map(level => {
            // 如果level=2，将名称改为 原名称 + "/总监"
            const name = level.level === 2 ? level.name + "/总监" : level.name;
            const identity = {
              id: level.id,
              name: name,
              level: level.level, // 保存level用于排序
              feeType: null, // 默认不选择
              feeList: [
                {
                  levelId: level.id,
                  type: 20,
                  amount: "",
                  giftAccountType: "",
                  balanceAmount: "",
                  coinAmount: "",
                  giftAmount: "",
                  tuition: ""
                }
              ]
            };
            // 根据身份类型设置默认的可用支付方式
            identity.enabledPayments = this.getAvailablePayments(identity);
            return identity;
          })
          .sort((a, b) => (b.level || 0) - (a.level || 0)); // 按level从大到小排序

        //技术线
        const techTeacher = {
          id: 30,
          name: "技术老师",
          level: 30, // 保存level用于排序
          feeType: null, // 默认不选择
          feeList: [
            {
              levelId: "",
              type: 30,
              amount: "",
              giftAccountType: "",
              balanceAmount: "",
              coinAmount: "",
              giftAmount: "",
              tuition: ""
            }
          ]
        };
        techTeacher.enabledPayments = this.getAvailablePayments(techTeacher);
        this.identityList.push(techTeacher);

        //内部员工
        const internalEmployee = {
          id: 10,
          name: "内部员工",
          level: "", // 保存level用于排序
          feeType: null, // 默认不选择
          feeList: [
            {
              levelId: "",
              type: 10,
              amount: "",
              giftAccountType: "",
              balanceAmount: "",
              coinAmount: "",
              giftAmount: "",
              tuition: ""
            }
          ]
        };
        internalEmployee.enabledPayments = this.getAvailablePayments(
          internalEmployee
        );
        this.identityList.push(internalEmployee);

        //儿童
        const childTicket = {
          id: 70,
          name: "儿童票",
          level: "", // 保存level用于排序
          feeType: null, // 默认不选择
          feeList: [
            {
              levelId: "",
              type: 70,
              amount: "",
              giftAccountType: "",
              balanceAmount: "",
              coinAmount: "",
              giftAmount: "",
              tuition: ""
            }
          ]
        };
        childTicket.enabledPayments = this.getAvailablePayments(childTicket);
        this.identityList.push(childTicket);
      } catch (error) {
        console.error("加载身份列表失败:", error);
        this.identityList = [];
      }
    },
    getBisicsInfo() {
      sysDataconstantApi
        .fetchBatchCode({ code: "defaultSignInRadius,maxSignInRadius" })
        .then(({ data }) => {
          const { list } = data;
          console.log(list);
          if (list.length > 0) {
            const find = list.find(item => item.code === "defaultSignInRadius");
            const find1 = list.find(item => item.code === "maxSignInRadius");
            this.defaultRadiusValue = find.content;
            // this.maxRadiusValue = find1.content;
          }
        });
    },
    changeSignUpRadius() {
      const { signUpRadius } = this.form;
      if (+signUpRadius > +this.maxRadiusValue) {
        this.$set(this.form, "signUpRadius", this.maxRadiusValue);
      }
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child);
        }
      }
      return data;
    },
    //选择地址
    handlePositionDialog(val) {
      this.addAddressShow = false;
      this.form.address = val.mapText;
      this.form.latitude = val.latitude;
      this.form.longitude = val.longitude;
    },
    updatePositionDialog(val) {
      this.addAddressShow = val;
    },
    handleCloes(val) {
      this.addAddressShow = val;
    },

    changeCascader() {
      const { addressArray } = this.form;
      this.form.provinceCode = addressArray[0];
      this.form.cityCode = addressArray[1];
      this.form.districtCode = addressArray[2];
    },
    handleActive(item) {
      item.isActive = !item.isActive;
      this.$forceUpdate();
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.imgUrl = "";
      this.form = initFormBean();
      // 重新加载身份列表，确保数据被清理
      this.loadIdentityList();
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm();
      if (!this.form.id && this.defaultRadiusValue) {
        this.$set(this.form, "signUpRadius", this.defaultRadiusValue);
      }
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleUpdate(row) {
      const editData = { ...row };
      editData.participationType =
        editData.feeList && editData.feeList.length > 0 ? 2 : 1;

      // 优先处理 lecturerList（对象数组），从中提取 id 数组
      if (
        editData.lecturerList &&
        Array.isArray(editData.lecturerList) &&
        editData.lecturerList.length > 0
      ) {
        editData.lecturerIds = editData.lecturerList
          .map(lecturer => lecturer.id)
          .filter(id => id !== null && id !== undefined)
          .map(id => Number(id))
          .filter(id => !isNaN(id));
      }
      // 如果后端返回的是 lecturerId（单数），转换为 lecturerIds（数组）
      else if (
        editData.lecturerId !== undefined &&
        editData.lecturerId !== null
      ) {
        editData.lecturerIds = Array.isArray(editData.lecturerId)
          ? editData.lecturerId
          : [editData.lecturerId];
        delete editData.lecturerId;
      }
      // 如果已经有 lecturerIds，确保格式正确
      else if (editData.lecturerIds) {
        // 确保 lecturerIds 是数组格式，并且值是数字类型
        if (!Array.isArray(editData.lecturerIds)) {
          editData.lecturerIds = [editData.lecturerIds];
        }
        editData.lecturerIds = editData.lecturerIds
          .map(id => Number(id))
          .filter(id => !isNaN(id));
      } else {
        editData.lecturerIds = [];
      }

      this.resetForm();
      this.form = editData;
      this.calcEditData();
      this.formVisible = true;
    },
    calcEditData() {
      const {
        startTime,
        endTime,
        signUpStartTime,
        signUpEndTime,
        imageUrl,
        bannerUrl,
        lecturerIds,
        lecturerList,
        provinceCode,
        cityCode,
        districtCode
      } = this.form;

      // 优先处理 lecturerList（对象数组），从中提取 id 数组
      let processedLecturerIds = [];
      if (
        lecturerList &&
        Array.isArray(lecturerList) &&
        lecturerList.length > 0
      ) {
        processedLecturerIds = lecturerList
          .map(lecturer => lecturer.id)
          .filter(id => id !== null && id !== undefined)
          .map(id => Number(id))
          .filter(id => !isNaN(id));
      } else if (lecturerIds) {
        // 如果已经有 lecturerIds，确保格式正确
        processedLecturerIds = Array.isArray(lecturerIds)
          ? lecturerIds
          : [lecturerIds];
        processedLecturerIds = processedLecturerIds
          .map(id => Number(id))
          .filter(id => !isNaN(id));
      }

      this.$set(this.form, "lecturerIds", processedLecturerIds);
      // 省市区
      this.$set(this.form, "addressArray", [
        provinceCode,
        cityCode,
        districtCode
      ]);
      // 时间
      this.$set(this.form, "meetingTime", [startTime, endTime]);
      this.$set(this.form, "signTime", [signUpStartTime, signUpEndTime]);
      // 图片
      this.imgUrl = imageUrl;
      // banner 图
      this.$set(this.form, "bannerUrl", this.clacArrObj(bannerUrl));

      // 根据后端feeList回填身份费用配置
      this.populateIdentityFeesFromBackend();
    },
    clacArrObj(str) {
      if (!str) return [];
      const arr = str.split(",");
      const newArr = [];
      arr.forEach(item => {
        newArr.push({ url: item });
      });
      return newArr;
    },
    calcParams() {
      const params = JSON.parse(JSON.stringify(this.form));
      // 格式化时间为 YYYY-MM-DD HH:mm:ss 格式
      params.startTime = this.formatDateTime(params.meetingTime[0]);
      params.endTime = this.formatDateTime(params.meetingTime[1]);
      params.signUpStartTime = this.formatDateTime(params.signTime[0]);
      params.signUpEndTime = this.formatDateTime(params.signTime[1]);

      // 构建feeList
      params.feeList = [];

      // 如果选择了"所有人参与"，将所有身份都作为免费添加到feeList
      if (params.participationType === 1) {
        // 所有人免费参与，feeList 为空数组
        params.feeList = [];
        return params;
      }

      // 指定身份参与的情况
      for (const identity of this.identityList) {
        if (identity.feeType === 2) {
          // 选择了收费
          for (const fee of identity.feeList) {
            // 获取type值，如果不存在则根据身份设置默认值
            let feeType = fee.type;
            if (!feeType) {
              if (identity.id === 30) {
                feeType = 30; // 技术老师
              } else if (identity.id === 70) {
                feeType = 70; // 儿童票
              } else if (identity.id === 10) {
                feeType = 10; // 内部员工
              } else {
                feeType = 20; // 默认
              }
            }

            // 根据启用的支付方式决定传值还是传null
            const enabledPayments = identity.enabledPayments || [];

            const feeItem = {
              levelId: identity.level || identity.id,
              type: feeType, // 确保type字段始终存在
              // 现金收费：如果启用且有值则传值，如果启用但无值则传0，如果未启用则传null
              amount: enabledPayments.includes("cash")
                ? fee.amount && fee.amount !== ""
                  ? parseFloat(fee.amount)
                  : 0
                : null,
              // 余额收费：如果启用且有值则传值，如果启用但无值则传0，如果未启用则传null
              balance: enabledPayments.includes("balance")
                ? fee.balanceAmount && fee.balanceAmount !== ""
                  ? parseFloat(fee.balanceAmount)
                  : 0
                : null,
              // 零售价收费：如果启用且有值则传值，如果启用但无值则传0，如果未启用则传null
              xiaoduCoin: enabledPayments.includes("coin")
                ? fee.coinAmount && fee.coinAmount !== ""
                  ? parseFloat(fee.coinAmount)
                  : 0
                : null,
              // 赠送额度收费：如果启用且有值则传值，如果启用但无值则传0，如果未启用则传null
              tuition: enabledPayments.includes("gift")
                ? fee.tuition && fee.tuition !== ""
                  ? parseFloat(fee.tuition)
                  : 0
                : null,
              // 入账金额类型：如果启用且有值则传值，如果启用但无值则传0，如果未启用则传null
              giftAccountType: enabledPayments.includes("account")
                ? fee.giftAccountType || 0
                : null,
              // 入账金额：如果启用且有值则传值，如果启用但无值则传0，如果未启用则传null
              giftAmount: enabledPayments.includes("account")
                ? fee.giftAmount && fee.giftAmount !== ""
                  ? parseFloat(fee.giftAmount)
                  : 0
                : null,
              feeType: identity.feeType
            };
            params.feeList.push(feeItem);
          }
        } else if (identity.feeType === 1) {
          // 选择了免费，也需要添加到feeList中，费用为0
          // 获取默认的type值，优先从feeList中获取，如果没有则根据身份类型设置默认值
          let defaultType = 20; // 默认类型
          if (
            identity.feeList &&
            identity.feeList.length > 0 &&
            identity.feeList[0].type
          ) {
            defaultType = identity.feeList[0].type;
          } else if (identity.id === 30) {
            defaultType = 30; // 技术老师
          } else if (identity.id === 70) {
            defaultType = 70; // 儿童票
          } else if (identity.id === 10) {
            defaultType = 10; // 内部员工
          }

          const freeFeeItem = {
            levelId: identity.level || identity.id,
            type: defaultType,
            amount: 0,
            balance: 0,
            xiaoduCoin: 0,
            tuition: 0,
            giftAccountType: 0,
            feeType: identity.feeType
          };
          params.feeList.push(freeFeeItem);
        } else {
          //选择了指定身份参与，又不选择费用，数据按照选择收费的模式，创建一条数据，金额填-1，用来区分所有人免费或者指定身份参与又没有选择费用
          // 获取默认的type值
          let defaultType = 20; // 默认类型
          if (
            identity.feeList &&
            identity.feeList.length > 0 &&
            identity.feeList[0].type
          ) {
            defaultType = identity.feeList[0].type;
          } else if (identity.id === 30) {
            defaultType = 30; // 技术老师
          } else if (identity.id === 70) {
            defaultType = 70; // 儿童票
          } else if (identity.id === 10) {
            defaultType = 10; // 内部员工
          }

          // 获取该身份支持的支付方式列表
          const availablePayments = this.getAvailablePayments(identity);
          // 获取用户选择的支付方式（可能为空数组）
          const enabledPayments = identity.enabledPayments || [];

          // 判断某个支付方式是否支持配置
          const isPaymentSupported = paymentType => {
            return availablePayments.includes(paymentType);
          };

          // 判断某个支付方式是否已选择
          const isPaymentEnabled = paymentType => {
            return enabledPayments.includes(paymentType);
          };

          // 获取金额值：支持配置但没配置传-1，不支持配置传null
          const getAmountValue = paymentType => {
            if (!isPaymentSupported(paymentType)) {
              return null; // 不支持配置的，金额传null
            }
            if (!isPaymentEnabled(paymentType)) {
              return -1; // 支持配置的，没配置，金额传-1
            }
            return -1; // 即使选择了，但没选择费用，也传-1
          };

          const noFeeItem = {
            levelId: identity.level || identity.id,
            type: defaultType,
            // 现金收费
            amount: getAmountValue("cash"),
            // 余额收费
            balance: getAmountValue("balance"),
            // 零售价收费
            xiaoduCoin: getAmountValue("coin"),
            // 赠送额度收费
            tuition: getAmountValue("gift"),
            // 入账金额类型
            giftAccountType: getAmountValue("account"),
            // 入账金额
            giftAmount: getAmountValue("account"),
            feeType: identity.feeType
          };
          params.feeList.push(noFeeItem);
        }
      }

      return params;
    },
    // 格式化时间为 YYYY-MM-DD HH:mm:ss 格式
    formatDateTime(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 根据后端feeList回填身份费用配置
    populateIdentityFeesFromBackend() {
      // 如果 feeList 为空数组，说明是"所有人免费参与"
      if (!this.form.feeList || this.form.feeList.length === 0) {
        this.form.participationType = 1; // 所有人免费参与
        return;
      }
      // 如果后端返回的 participationType 为 1，也设置为"所有人免费参与"
      if (this.form.participationType === 1) {
        return;
      }
      // 遍历所有身份
      this.identityList.forEach(identity => {
        // 获取身份的默认 type
        const identityType =
          identity.feeList && identity.feeList[0] && identity.feeList[0].type
            ? identity.feeList[0].type
            : identity.id === 30
              ? 30
              : identity.id === 70
                ? 70
                : identity.id === 10
                  ? 10
                  : 20;
        // 根据 type 和 levelId 匹配费用
        const matchingFees = this.form.feeList.filter(fee => {
          // 对于特殊身份（技术老师、内部员工、儿童票），直接根据 type 匹配
          if (identity.id === 30 || identity.id === 70 || identity.id === 10) {
            return fee.type === identityType;
          }

          // 对于业务线身份（type 是 20、40、50、60），先匹配 levelId，然后匹配 type
          // levelId 可能是 identity.id（业务线身份的 id）或 identity.level（业务线身份的 level）
          if (
            identityType === 20 ||
            identityType === 40 ||
            identityType === 50 ||
            identityType === 60
          ) {
            const levelIdMatch =
              fee.levelId === identity.id || fee.levelId === identity.level;

            if (!levelIdMatch) {
              return false;
            }

            // 如果 levelId 匹配，还需要确保 fee.type 也是业务线类型（20/40/50/60），不能是特殊身份类型（10/30/70）
            // 这样可以避免 type: 30 的数据匹配到业务线身份
            const isBusinessLineType =
              fee.type === 20 ||
              fee.type === 40 ||
              fee.type === 50 ||
              fee.type === 60;
            return isBusinessLineType;
          }

          // 其他情况不匹配
          return false;
        });

        if (matchingFees.length > 0) {
          const fee = matchingFees[0];
          // 判断是否所有金额都是-1或null（表示选择了指定身份参与但没有选择费用）
          const allAmountsEmpty =
            (fee.amount === -1 ||
              fee.amount === null ||
              fee.amount === undefined ||
              fee.amount === 0) &&
            (fee.balance === -1 ||
              fee.balance === null ||
              fee.balance === undefined ||
              fee.balance === 0) &&
            (fee.xiaoduCoin === -1 ||
              fee.xiaoduCoin === null ||
              fee.xiaoduCoin === undefined ||
              fee.xiaoduCoin === 0) &&
            (fee.tuition === -1 ||
              fee.tuition === null ||
              fee.tuition === undefined ||
              fee.tuition === 0) &&
            (fee.giftAmount === -1 ||
              fee.giftAmount === null ||
              fee.giftAmount === undefined ||
              fee.giftAmount === 0) &&
            (fee.giftAccountType === -1 ||
              fee.giftAccountType === null ||
              fee.giftAccountType === undefined ||
              fee.giftAccountType === 0 ||
              fee.giftAccountType === "");

          // 如果所有金额都是-1或null，且不是免费，则设置为未选择费用
          if (allAmountsEmpty && !fee.isFree) {
            identity.feeType = null;
            identity.feeList = [];
            identity.enabledPayments = [];
          } else {
            // 找到匹配的费用取第一条数据的isFree字段
            identity.feeType = fee.isFree ? 1 : 2;
            // 填充费用数据，根据实际后端数据结构映射字段
            // 金额为-1表示支持配置但没配置，应该转换为空字符串
            identity.feeList = matchingFees.map(fee => ({
              levelId: fee.levelId || identity.level || identity.id, // 优先使用后端返回的 levelId
              type:
                fee.type ||
                (identity.feeList &&
                  identity.feeList[0] &&
                  identity.feeList[0].type) ||
                identityType, // 使用计算出的 identityType
              amount:
                fee.amount === 0 ||
                  fee.amount === -1 ||
                  fee.amount === null ||
                  fee.amount === undefined
                  ? ""
                  : fee.amount.toString(),
              giftAccountType:
                fee.giftAccountType === -1 ||
                  fee.giftAccountType === null ||
                  fee.giftAccountType === undefined ||
                  fee.giftAccountType === 0 ||
                  fee.giftAccountType === ""
                  ? ""
                  : fee.giftAccountType.toString(),
              balanceAmount:
                fee.balance === 0 ||
                  fee.balance === -1 ||
                  fee.balance === null ||
                  fee.balance === undefined
                  ? ""
                  : fee.balance.toString(),
              coinAmount:
                fee.xiaoduCoin === 0 ||
                  fee.xiaoduCoin === -1 ||
                  fee.xiaoduCoin === null ||
                  fee.xiaoduCoin === undefined
                  ? ""
                  : fee.xiaoduCoin.toString(),
              giftAmount:
                fee.giftAmount === 0 ||
                  fee.giftAmount === -1 ||
                  fee.giftAmount === null ||
                  fee.giftAmount === undefined
                  ? ""
                  : fee.giftAmount.toString(),
              tuition:
                fee.tuition === 0 ||
                  fee.tuition === -1 ||
                  fee.tuition === null ||
                  fee.tuition === undefined
                  ? ""
                  : fee.tuition.toString()
            }));

            // 根据实际填写的费用设置启用的支付方式
            const enabledPayments = [];
            if (identity.feeList[0].amount !== "") {
              enabledPayments.push("cash");
            }
            if (
              identity.feeList[0].giftAccountType !== "" ||
              identity.feeList[0].giftAmount !== ""
            ) {
              enabledPayments.push("account");
            }
            if (identity.feeList[0].balanceAmount !== "") {
              enabledPayments.push("balance");
            }
            if (identity.feeList[0].coinAmount !== "") {
              enabledPayments.push("coin");
            }
            if (identity.feeList[0].tuition !== "") {
              enabledPayments.push("gift");
            }

            identity.enabledPayments = enabledPayments;
          }
        } else {
          // 没有找到匹配的费用配置，保持未选择状态
          identity.feeType = null;
          identity.feeList = [];
          identity.enabledPayments = [];
        }
      });
    },
    doCreate() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // 验证费用配置
          const feeValidationError = this.validateFeeConfiguration();
          if (feeValidationError) {
            return this.$message.error(feeValidationError);
          }

          const params = this.calcParams();

          // 验证：如果选择了"指定身份参与"，feeList 不能为空
          if (
            params.participationType === 2 &&
            (!params.feeList || params.feeList.length === 0)
          ) {
            return this.$message.error("请至少配置一个身份的费用信息");
          }

          let isTram = false;
          params.feeList.forEach(item => {
            // 只验证启用的收费方式，未启用的可以为null
            // amount为null表示未启用现金收费，这是合法的，只有undefined才报错
            if (item.amount === undefined) {
              isTram = true;
            } else if (item.amount !== null) {
              item.amount = +item.amount;
            }
            // if (item.levelId === 7 && (!item.giftAccountType || !item.giftAmount)) isTram = true
            // if (item.levelId === 6 && (!item.giftAccountType || !item.giftAmount)) isTram = true
            // 入账金额：如果为null则保持null，否则转换为数字（0或实际值）
            if (
              item.giftAmount !== null &&
              item.giftAmount !== undefined &&
              item.giftAmount !== ""
            ) {
              item.giftAmount = +item.giftAmount;
            }
            // giftAccountType：如果为null则保持null，否则使用原值或0
            if (
              item.giftAccountType !== null &&
              item.giftAccountType !== undefined
            ) {
              item.giftAccountType = item.giftAccountType || 0;
            }
            delete item.operatedTime;
          });
          if (isTram) return this.$message.error("请输入报名费用");
          params.maxCarryChildPer = +params.maxCarryChildPer || 0;
          params.maxCarryPeople = +params.maxCarryPeople || 0;
          params.signUpCountVirtual = +params.signUpCountVirtual || 0;
          params.signUpRadius = +params.signUpRadius || 0;
          params.bannerUrl =
            params.bannerUrl && params.bannerUrl.length
              ? params.bannerUrl.map(banner => banner.url).toString()
              : "";
          // if (new Date(params.signUpEndTime.replace(/\-/g, "/")).getTime() > new Date(params.startTime.replace(/\-/g, "/")).getTime()) return this.$message.error('会议开始时间要大于报名结束时间！')

          this.submitGoods({ ...params });
        }
      });
    },
    submitGoods(params) {
      params.feeList = params.feeList.map(item => {
        return {
          ...item,
          isFree: item.feeType === 1
        };
      });
      delete params.addressArray;
      delete params.meetingTime;
      delete params.signTime;
      if (this.isRepSub) return;
      this.isRepSub = true;
      if (params.id > 0) {
        meetingApi
          .update(params)
          .then(data => {
            this.postCallback(data);
          })
          .catch(res => {
            this.isRepSub = false;
          });
      } else {
        meetingApi
          .create(params)
          .then(data => {
            this.postCallback(data);
          })
          .catch(res => {
            this.isRepSub = false;
          });
      }
    },
    postCallback(data) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.$emit("created");
    },
    selectImage() {
      this.$refs.selectImgVue.handleCreate();
    },
    handleSelectImg(find) {
      this.imgUrl = find.url;
      this.form.imageId = find.id;
    },
    // 新增方法
    selectCategory(categoryId) {
      this.form.categoryId = categoryId;
    },
    handleParticipationTypeChange(value) {
      console.log("参与类型变更:", value);
      console.log("当前form.participationType:", this.form.participationType);
    },
    // 处理身份费用类型变更
    // 处理单选框点击，支持取消选中
    handleRadioClick(identity, value, event) {
      // 如果点击的是已选中的选项，则取消选中
      if (identity.feeType === value) {
        event.preventDefault();
        this.$set(identity, "feeType", null);
        this.handleIdentityFeeChange(identity);
      }
    },
    handleIdentityFeeChange(identity) {
      console.log("身份费用类型变更:", identity.name, identity.feeType);

      // 如果取消选择（feeType为null），清空费用配置
      if (identity.feeType === null) {
        identity.feeList = [];
        identity.enabledPayments = [];
        return;
      }

      // 如果选择免费，保留type信息但清空费用配置
      if (identity.feeType === 1) {
        // 保存默认的type值
        let defaultType = 20; // 默认类型
        if (
          identity.feeList &&
          identity.feeList.length > 0 &&
          identity.feeList[0].type
        ) {
          defaultType = identity.feeList[0].type;
        } else if (identity.id === 30) {
          defaultType = 30; // 技术老师
        } else if (identity.id === 70) {
          defaultType = 70; // 儿童票
        } else if (identity.id === 10) {
          defaultType = 10; // 内部员工
        }
        // 保留feeList结构但费用为0，用于后续提交
        identity.feeList = [
          {
            levelId: identity.level || identity.id,
            type: defaultType,
            amount: "",
            giftAccountType: "",
            balanceAmount: "",
            coinAmount: "",
            giftAmount: "",
            tuition: ""
          }
        ];
        identity.enabledPayments = [];
        return;
      }

      // 如果选择收费，确保有费用配置
      if (identity.feeType === 2) {
        // 如果feeList为空，创建新的费用配置
        if (!identity.feeList || identity.feeList.length === 0) {
          // 获取默认的type值：技术老师=30，儿童票=70，内部员工=10，其他=20
          let defaultType = 20;
          if (identity.id === 30) {
            defaultType = 30; // 技术老师
          } else if (identity.id === 70) {
            defaultType = 70; // 儿童票
          } else if (identity.id === 10) {
            defaultType = 10; // 内部员工
          } else if (
            identity.feeList &&
            identity.feeList.length > 0 &&
            identity.feeList[0].type
          ) {
            defaultType = identity.feeList[0].type;
          }

          identity.feeList = [
            {
              levelId: identity.level || identity.id,
              type: defaultType,
              amount: "",
              giftAccountType: "",
              balanceAmount: "",
              coinAmount: "",
              giftAmount: "",
              tuition: ""
            }
          ];
        } else {
          // 如果feeList已存在但缺少type字段，补充type字段
          identity.feeList.forEach(fee => {
            if (!fee.type) {
              // 根据身份设置默认type
              if (identity.id === 30) {
                fee.type = 30; // 技术老师
              } else if (identity.id === 70) {
                fee.type = 70; // 儿童票
              } else if (identity.id === 10) {
                fee.type = 10; // 内部员工
              } else {
                fee.type = 20; // 默认
              }
            }
          });
        }
        // 无论feeList是否为空，都更新enabledPayments为允许的支付方式
        // 这样切换身份时会自动勾选所有允许的支付方式
        identity.enabledPayments = this.getAvailablePayments(identity);
      }
    },
    // 处理支付方式变更
    handlePaymentMethodsChange(identity) {
      console.log("支付方式变更:", identity.name, identity.enabledPayments);
      console.log(
        "现金收费是否启用:",
        identity.enabledPayments.includes("cash")
      );
      // 清空被禁用的支付方式的金额
      identity.feeList.forEach(fee => {
        if (!identity.enabledPayments.includes("cash")) {
          fee.amount = "";
        }
        if (!identity.enabledPayments.includes("account")) {
          fee.giftAccountType = "";
          fee.giftAmount = "";
        }
        if (!identity.enabledPayments.includes("balance")) {
          fee.balanceAmount = "";
        }
        if (!identity.enabledPayments.includes("coin")) {
          fee.coinAmount = "";
        }
        if (!identity.enabledPayments.includes("gift")) {
          fee.tuition = "";
        }
      });
    },
    // 根据身份获取可用的支付方式
    getAvailablePayments(identity) {
      const level = identity.level;
      const name = identity.name;

      // 1. level 1和2、8，以及type 30（技术老师）、10（内部员工）：只支持现金支付，不支持入账
      if (
        [1, 2, 8].indexOf(level) >= 0 ||
        identity.id === 30 ||
        identity.id === 10
      ) {
        return ["cash"];
      }

      // 2. 体验班/研修班/儿童：支持所有收费方式，包括入账
      if (name === "体验班" || name === "研修班" || name === "儿童票") {
        return ["cash", "account", "balance", "coin", "gift"];
      }

      // 3. 大区经理、地区经理、县区经理：支持现金和零售价支付，包括入账
      if (name === "大区经理" || name === "地区经理" || name === "县区经理") {
        return ["cash", "account", "coin"];
      }

      // 默认支持所有方式
      return ["cash", "account", "balance", "coin", "gift"];
    },
    // 根据身份获取可用的入账类型
    getAccountTypeOptions(identity, fee) {
      const level = identity.level;
      const options = [];
      const legacyLabels = { 1: "余额", 2: "零售价", 3: "学费赠送" };
      // 历史会议里配过、但新口径下不再允许的值：以 disabled 项显示出来，
      // 否则 Element 会把原值渲染成裸数字，用户看到后端报错却不知道改哪一行
      const withLegacy = opts => {
        const cur = fee && Number(fee.giftAccountType);
        if (cur > 0 && !opts.some(o => o.value === cur) && legacyLabels[cur]) {
          opts.push({ label: `${legacyLabels[cur]}(已停用，请改选)`, value: cur, disabled: true });
        }
        return opts;
      };

      // 1. level 1和2：不支持入账
      if (level === 1 || level === 2) {
        return options; // 返回空数组，不显示任何选项
      }

      // 2. 加盟商报名费上账（财务 2026-08-25 口径，BUG-2026-441868）：
      //    研修班只能上余额账户(220301)，体验班只能上学费赠送账户(224103)，
      //    零售价账户(224108)不再作为加盟商报名费的上账账户。
      //    儿童票不在财务口径内且历史上从未配过赠送额，维持原选项不动，待产品/财务定。
      if (identity.name === "研修班") {
        options.push({ label: "余额", value: 1 });
      }
      if (identity.name === "体验班") {
        options.push({ label: "学费赠送", value: 3 });
      }
      if (identity.name === "儿童票") {
        options.push({ label: "余额", value: 1 });
        options.push({ label: "零售价", value: 2 });
      }

      // 3. 大区经理、地区经理、县区经理：只支持零售价
      if (this.isRetailOnlyAccount(identity)) {
        options.push({ label: "零售价", value: 2 });
      }

      return withLegacy(options);
    },
    /**
     * 这个身份的「入账金额」是不是只能走零售价账户。
     * 大区经理 / 地区经理 / 县区经理三类如此 —— 表头那句红色提示和
     * getAccountTypeOptions 里的第 3 条规则**共用这一个判据**，只在这里列名字。
     */
    isRetailOnlyAccount(identity) {
      return RETAIL_ONLY_ACCOUNT_IDENTITIES.includes(identity && identity.name);
    },
    // 判断是否可以添加费用行（level6、level7可以多行）
    canAddFeeRow(identity) {
      const multiRowLevels = [6, 7];
      return multiRowLevels.includes(identity.level);
    },
    getFeeOrderText(index) {
      return `第${index + 1}位报名`;
    },
    addFeeRow(identity) {
      // 获取当前身份的默认type值
      const defaultType =
        (identity.feeList &&
          identity.feeList.length > 0 &&
          identity.feeList[0].type) ||
        (identity.id === 30
          ? 30
          : identity.id === 70
            ? 70
            : identity.id === 10
              ? 10
              : 20);
      identity.feeList.push({
        levelId: identity.level || identity.id,
        type: defaultType,
        amount: "",
        giftAccountType: "",
        balanceAmount: "",
        coinAmount: "",
        giftAmount: "",
        tuition: ""
      });
    },
    removeFeeRow(identity, index) {
      identity.feeList.splice(index, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.meeting-box {
  ::v-deep .el-dialog {
    border-radius: 16px;

    .el-dialog__header {
      padding: 6px 30px;
      background-color: #e9f3f7;

      .el-dialog__title {
        color: #4680e3;
      }

      .el-dialog__headerbtn {
        top: 8px;
      }
    }

    .el-dialog__body {
      background-color: #f8f8f8;
    }
  }
}

.meeting-form {
  padding: 0 20px;
}

.form-section {
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 20px;
  background: #ffffff;

  .section-title {
    margin: 0 0 20px 0;
    font-size: 16px;
    color: #000000;
    padding-bottom: 10px;
  }

  .category-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

    .el-button {
      margin: 0;
      border-radius: 6px;
      padding: 8px 16px;
      font-size: 14px;
      border: 1px solid #dcdfe6;
      background-color: #f5f7fa;
      color: #606266;
      transition: all 0.3s;

      &:hover {
        border-color: #409eff;
        color: #409eff;
      }

      &.category-active {
        background-color: #409eff;
        border-color: #409eff;
        color: #fff;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;

    ::v-deep .el-form-item__label {
      font-size: 15px;
      color: #666666;
      font-weight: 400;
    }
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.full-width {
  grid-column: 1 / -1;

  .el-form-item {}

  .form-tip {
    font-size: 12px;
    color: #e73f3f;
    margin-top: 5px;
  }

  .required-field {
    ::v-deep .el-form-item__label {
      &::before {
        content: "*";
        color: #e73f3f;
        margin-right: 4px;
      }
    }
  }
}

// 针对特定表单项去掉左边距
.no-margin-left {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.image-upload {
  display: flex;
  align-items: center;
  gap: 10px;

  .preview-image {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
}

.participation-type {
  margin-bottom: 20px;
  padding: 15px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e6e6e6;
}

.identity-config {
  margin-top: 20px;

  .identity-type {
    margin-bottom: 20px;
    padding: 15px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
}

.fee-config-section {
  .fee-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}

.fee-config-table {
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-top: 16px;

  .table-header {
    display: grid;
    grid-template-columns: 120px 1fr 1fr 1fr 1fr 1fr 80px;
    background: #f5f7fa;
    font-weight: 600;
    color: #333;

    .header-cell {
      padding: 12px 8px;
      border-right: 1px solid #e6e6e6;
      text-align: center;
      font-size: 14px;

      &:last-child {
        border-right: none;
      }

      // 星号标红样式
      .required-asterisk {
        color: #e73f3f;
      }

      // 「请换算为零售价的入账金额进行配置」——表头里的红色提示。
      // font-weight 要显式回正常：父级 .table-header 是 600，继承过来会显得像另一个表头。
      .account-amount-hint {
        margin-top: 2px;
        color: #e73f3f;
        font-size: 12px;
        font-weight: normal;
        line-height: 16px;
        white-space: normal;
      }
    }
  }

  .table-body {
    .table-row {
      display: grid;
      grid-template-columns: 120px 1fr 1fr 1fr 1fr 1fr 80px;
      border-bottom: 1px solid #e6e6e6;

      &:last-child {
        border-bottom: none;
      }

      .table-cell {
        padding: 8px;
        border-right: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
        justify-content: center;

        &:last-child {
          border-right: none;
        }

        .el-input,
        .el-select {
          width: 100%;
        }
      }
    }
  }
}

.identity-list {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .identity-item {
    padding: 15px;
    background: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 6px;

    >div {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .identity-name {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      margin-right: 20px;
      min-width: 80px;
    }

    .identity-options {
      .el-radio-group {
        .el-radio {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .payment-methods {
      margin-left: 20px;

      .el-checkbox-group {
        .el-checkbox {
          margin-right: 15px;
          margin-bottom: 5px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  border-radius: 4px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

::v-deep .meeting-box .el-dialog__body {
  padding: 10px 0;
}

::v-deep .el-select,
::v-deep .el-cascader,
::v-deep .el-date-editor--datetimerange.el-input,
::v-deep .el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

::v-deep .el-checkbox {
  margin-right: 10px;
}

.address {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 12;
}

::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .fee-config-table {

    .table-header,
    .table-row {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }
}
</style>
